import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {PsdRules} from '../core/models/psd-rules';

export const PSD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/;

export const DEFAULT_PSD_RULES: PsdRules = {
  minLength: 8,
  requireDigit: true,
  requireLowercase: true,
  requireUppercase: true,
  requireNonAlphanumeric: true,
  requiredUniqueChars: 1,
  historyDepth: 3,
};

export const PSD_VALIDATORS = psdValidators(DEFAULT_PSD_RULES);

export function psdValidators(rules: PsdRules): ValidatorFn[] {
  const validators: ValidatorFn[] = [
    Validators.required,
    Validators.minLength(rules.minLength),
  ];

  const lookaheads: string[] = [];
  if (rules.requireLowercase) lookaheads.push('(?=.*[a-z])');
  if (rules.requireUppercase) lookaheads.push('(?=.*[A-Z])');
  if (rules.requireDigit) lookaheads.push('(?=.*\\d)');
  if (rules.requireNonAlphanumeric) lookaheads.push('(?=.*[^A-Za-z0-9])');

  if (lookaheads.length) {
    validators.push(Validators.pattern(new RegExp(`^${lookaheads.join('')}.+$`)));
  }

  if (rules.requiredUniqueChars > 1) {
    validators.push(uniqueCharsValidator(rules.requiredUniqueChars));
  }

  return validators;
}

export function uniqueCharsValidator(requiredUniqueChars: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value ?? '';
    if (!value) return null;

    return new Set(value).size >= requiredUniqueChars
      ? null
      : {uniqueChars: {required: requiredUniqueChars}};
  };
}
